module.exports = __webpack_public_path__ + "assets/img/banner-center1.de01512b.jpg";